import axiosInstance from "../axios";
import axios from "axios";

export const userService = {
  mainLogin,
  login,
  logout,
  getUserInfo,
  getGeoLocation,
};
const getBaseurl = () => {
  if (window?.location?.href) {
    const url = window?.location?.href;
    const firstDotIndex = url.indexOf(".");
    const valueBeforeFirstDot = url.substring(0, firstDotIndex);
    const urlDomain = valueBeforeFirstDot + `-login.edusity.com`;
    return urlDomain;
  }
};
function mainLogin(username, password) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  };

  return fetch(`${getBaseurl()}/main-login`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      if (!res.error) localStorage.setItem("main-login", "true");
      return res;
    });
}

function login(username, password) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email: username, password }),
  };

  return fetch(`${getBaseurl()}/login`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      if (!res.error)
        localStorage.setItem("token", JSON.stringify(res?.data?.token));

      return res;
    });
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem("token");
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        logout();
        window.location.reload(true);
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

function getUserInfo() {
  return axiosInstance
    .get("user")
    .then((res) => res)
    .catch((error) => console.log(error));
}

function getGeoLocation() {
  return axios
    .get("https://geolocation-db.com/json/8dd79c70-0801-11ec-a29f-e381a788c2c0")
    .then((res) => res)
    .catch((error) => error);
}
